import React from 'react'
import ReactDOM from 'react-dom/client'
import './global.css'

import App from './App'

const root = ReactDOM.createRoot(document.getElementById('root')!)

// Setup MSW mock server in both development and production
// Certify MSW's Service Worker is available before starting React app
// import('../mocks/browser')
//   .then(async ({ worker }) => {
//     return worker.start()
//   }) // Run <App /> when Service Worker is ready to intercept requests
//   .then(() => {
//     root.render(<App />)
//   })

async function prepareApp() {
  // ⭐ 只在开发环境启用 MSW
  // if (import.meta.env.DEV) {
  //   const { worker } = await import('../mocks/browser')
  //   await worker.start({
  //     onUnhandledRequest: 'bypass',
  //   })
  // }

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  )
}
prepareApp()
